const {Vue, jQuery: $} = window;

import {
	convertName,
	launchConfigurator,
	getRegionDir,
	getUiCopy
} from "../_utilities";
import { ACTIONS } from "../_actions";
import {store, store$} from "../_config-store";
import { localize } from "../_localize.js";

const truckCabs$ = store$
	.map(state => state.truckCabs);

const dataReady$ = store$
	.map(state => state.dataReady);

const dataLoaded = $.Deferred();

export const options = {
	template:
	`<div>
		<h1 class="heading-2" v-html="heading"></h1>
		<p v-html="uiCopy.cabSelectHeader || ''"></p>
		<div>
			<section v-for="tc in truckCabs">
				<h2>{{ local(tc.label) }}</h2>
				<comp-card-list columns="3">
					<div>
						<a v-for="truckCab in tc.cabs" v-on:click="setTruck(tc.key,truckCab)">
							<comp-image><img :src="imagePath(truckCab, truckModel)"></comp-image>
							<h3>{{ local(truckCab) }}</h3>
						</a>
					</div>
				</comp-card-list>
			</section>
			<template v-if="dataReady">{{dataLoaded()}}</template>
		</div>
		<p v-html="uiCopy.cabSelectFooter || ''"></p>
	</div>`,
	subscriptions: function() {
		return {
			truckCabs: truckCabs$,
			dataReady: dataReady$,
		}
	},
	data() {
		return {
			tags: {},
			regionDir: getRegionDir(),
			uiCopy: getUiCopy(),
			heading: '',
			local(str){
				return str;
			}
		}
	},
	methods: {
		dataLoaded: function(){
			dataLoaded.resolve();
			if(window.tellParent){
				window.tellParent.loaded();
			}
		},
		setTruck: function(cab, truckCab){
			$("body").addClass("configurator-open");
			$("#configurator").addClass("open");

			if(this.dataReady){
				cabChange(cab,truckCab);
			}
			else {
				dataLoaded.done(() => {
					cabChange(cab,truckCab);
				});
			}
		},
        imagePath: function(cab, model) {    
			let { mediaHostAddress } = window;
			return (mediaHostAddress || '') + "/images/region/" + this.regionDir + '/cabs/' + convertName(model, "-") + '/' + convertName(cab, "-") + ".png?auto=format%2Ccompress&fm=jp2%2Cjpg&bg=d7d7d7";
		}
	},
	created(){
		localize().then( local => this.local = local );
		this.heading = $('[cab-choose-hero]').attr('heading');
	}
}

function cabChange(cab,truckCab){
	store.dispatch({
		type: ACTIONS.CAB_CHANGE,
		data: {
			cabType: cab,
			truckCab: truckCab
		}
	});
}

Vue.component('cab-types',options);